import { Box, Button, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Image from 'next/image';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '550px',
    display: 'flex',
    width: '100%',
    backgroundColor: '#F8F3E6',
    padding: '60px 80px 10px 80px',
    marginBottom: '80px',
    [theme.breakpoints.down('xl')]: {
      height: 'auto',
      padding: '40px 20px 10px 20px',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      padding: '40px 16px 5px 16px',
      height: 'auto',
    },
  },
  child1: {
    paddingRight: '32px',
    [theme.breakpoints.down('md')]: {
      paddingTop: '52.75vw',
      paddingBottom: '40px',
    },
  },

  imageContainer: {
    position: 'relative',
    borderTopLeftRadius: '48%',
    borderTopRightRadius: '48%',
    overflow: 'hidden',
    width: '448px',
    height: '550px',
    [theme.breakpoints.down('xl')]: {
      width: '350px',
      height: '450px',
    },
    [theme.breakpoints.down('md')]: {
      width: '448px',
      height: '550px',
    },
    [theme.breakpoints.down('md')]: {
      width: '320px',
      height: '400px',
    },
  },
  subtitle: {
    fontFamily: 'Playfair Display',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '28px',
    marginBottom: 0,
    paddingBottom: '8px',
    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      lineHeight: '24px',
    },
  },
  title: {
    fontFamily: 'Playfair Display',
    fontSize: '36px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '54px',
    [theme.breakpoints.down('md')]: {
      fontSize: '24px',
      lineHeight: '42px',
    },
  },
  description: {
    color: '#212121',
    fontFamily: 'Lato',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '27px',
    marginBottom: 0,
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      lineHeight: '24px',
    },
  },
  actionElement: {
    backgroundColor: '#3C8047',
    color: '#fff',
    padding: '10px 20px',
    fontSize: '16px',
    fontWeight: '700',
    textTransform: 'uppercase',
    borderRadius: '0',
    marginTop: '30px',
    '&:hover': {
      backgroundColor: 'rgb(42, 89, 49)',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      padding: '8px 16px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
      padding: '6px 12px',
    },
  },
}));

function HomeAndVacation({ node }) {
  const classes = useStyles();

  const {
    subtitle,
    description,
    title,
  } = node?.para?.[0];

  return (
    <Box className={classes.container}>
      <Box className={classes.child1}>
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Typography className={classes.subtitle}>
            {subtitle}
          </Typography>
          <Box
            style={{
              width: '150px',
              height: '2px',
              backgroundColor: '#000',
              marginLeft: '25px',
            }}
          />
        </Box>
        <Typography className={classes.title}>
          {title}
        </Typography>
        <Typography className={classes.description}>
        You’ll feel it the moment you enter the community. The tree lined streets, lush landscaping, and brick walkways. With its magnificent Clubhouse as its centerpiece, the feeling is traditional and memorable. Then there’s the world class Baywood Greens golf course that winds its way through the community creating backyard vistas like nothing else around. And if that weren’t enough, there’s marinas with boat slips with access to Rehoboth Bay and the Atlantic Ocean, beaches, restaurants, and shopping all just minutes away.
        </Typography>
        <Button className={classes.actionElement}>Discover Baywood</Button>
      </Box>
      <Box className={classes.child2}>
        <Box className={classes.imageContainer} style={{ position: 'relative' }}>
          <Image
            src="/images/golf-home-vacation.jpeg"
            fill={true}
            style={{ objectFit: 'cover' }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default HomeAndVacation;
